import { Component, Prop } from "vue-property-decorator";
import { AbsenceHistoriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceHistoriqueDto";
import { AbsenceHistoriqueTypeActionEnum } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceHistoriqueTypeActionEnum";
import { listeStatutsHistorique } from "../../../Helper/absencesHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { VueBase } from "../../Controls/VueBase";
import { StatutDisplay } from "../listeConge/listeConge";
import { ISidePanelHistorique } from "../../../shared/interfaces/sidePanelHistorique.interface";
import { EtatAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";

@Component
export default class SidePanelHistoriqueComponent extends VueBase {
	@Prop({ type: Object, required: true })
	public absence!: ISidePanelHistorique | null; // Absence sélectionnée pour afficher les détails

	public listeAbsenceHistorique: AbsenceHistoriqueDto[] = []; // Liste des historiques d'absences à afficher
	public isLoadingHistorique = false; // Indique si le chargement de l'historique est en cours
	public drawerIsVisible = false; // Indique si le panneau latéral est visible ou non

	/**
	 * Charge l'historique dès que le composant est monté.
	 */
	public mounted(): void {
		if (this.absence) {
			this.getHistoriqueAbsence();
			this.drawerIsVisible = true;
		}
	}

	/**
	 * Liste des statuts d'absences avec leurs propriétés d'affichage.
	 */
	public listeStatuts: StatutDisplay[] = listeStatutsHistorique;

	/**
	 * Computed
	 * Retourne le statut de l'absence actuelle avec ses propriétés d'affichage.
	 * Si aucune absence n'est sélectionnée, retourne null.
	 */
	public get statuts(): StatutDisplay | null {
		if (!this.absence) {
			return null;
		}

		return this.listeStatuts.find((s: StatutDisplay) => s.statut.includes(this.absence!.statut as EtatAbsencesEnum)) || null;
	}

	/**
	 * Gère la fermeture du panneau latéral.
	 */
	public handleClose(): void {
		this.$emit("close");
	}

	/**
	 * Récupère l'historique des actions pour l'absence sélectionnée.
	 */
	public getHistoriqueAbsence(): void {
		if (this.absence) {
			this.isLoadingHistorique = true;
			ServicesFactoryInstance.StatuAbsenceService.getHistoriqueAbsence(this.absence.id, (data) => {
				this.listeAbsenceHistorique = data;
				this.isLoadingHistorique = false;
			}, () => {
				this.isLoadingHistorique = false;
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de l'historique de l'absence.");
			});
		}
	}

	/**
	 * Retourne l'intitulé lisible d'une action d'historique d'absence.
	 * @param typeAction
	 * @returns string - Intitulé de l'action
	 */
	public getIntituleAction(typeAction: AbsenceHistoriqueTypeActionEnum): string {
		switch (typeAction) {
			case AbsenceHistoriqueTypeActionEnum.Creation:
				return "Création";
			case AbsenceHistoriqueTypeActionEnum.Modification:
				return "Modification";
			case AbsenceHistoriqueTypeActionEnum.Suppression:
				return "Suppression";
			case AbsenceHistoriqueTypeActionEnum.DemandeAnnulation:
				return "Demande d'annulation";
			case AbsenceHistoriqueTypeActionEnum.AnnulerDemandeAnnulation:
				return "Suppression de demande d'annulation";
			case AbsenceHistoriqueTypeActionEnum.Validation:
				return "Validation";
			case AbsenceHistoriqueTypeActionEnum.ValidationN1:
				return "Validation N1";
			case AbsenceHistoriqueTypeActionEnum.ValidationN2:
				return "Validation N2";
			case AbsenceHistoriqueTypeActionEnum.Refus:
				return "Refus";
			case AbsenceHistoriqueTypeActionEnum.RefusN1:
				return "Refus N1";
			case AbsenceHistoriqueTypeActionEnum.RefusN2:
				return "Refus N2";
			case AbsenceHistoriqueTypeActionEnum.ValidationAnnulation:
				return "Validation de l'annulation";
			case AbsenceHistoriqueTypeActionEnum.ValidationAnnulationN1:
				return "Validation de l'annulation N1";
			case AbsenceHistoriqueTypeActionEnum.ValidationAnnulationN2:
				return "Validation de l'annulation N2";
			case AbsenceHistoriqueTypeActionEnum.RefusAnnulation:
				return "Refus de l'annulation";
			case AbsenceHistoriqueTypeActionEnum.RefusAnnulationN1:
				return "Refus de l'annulation N1";
			case AbsenceHistoriqueTypeActionEnum.RefusAnnulationN2:
				return "Refus de l'annulation N2";
			case AbsenceHistoriqueTypeActionEnum.AnnulationAbsence:
				return "Annulation de l'absence";
			case AbsenceHistoriqueTypeActionEnum.AnnulationDemande:
				return "Annulation de la demande";
			default:
				return "Action inconnue";
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/sidePanelHistorique/sidePanelHistorique.ts